// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Biobanks-module_check_and_notes_container_LK_1Z {
  display: flex;
  gap: 8px;
}

.Biobanks-module_biobank_button_container_Y6X0a {
  margin-top: 8px;
  display: inline-flex;
  gap: 10px;
  justify-content: center;
}

.Biobanks-module_biobank_button_container_Y6X0a > * {
  flex: 1 1 50%;
}

.Biobanks-module_delete_button_y8wYC {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Biobanks/Biobanks.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb","sourcesContent":[".check_and_notes_container {\n  display: flex;\n  gap: 8px;\n}\n\n.biobank_button_container {\n  margin-top: 8px;\n  display: inline-flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.biobank_button_container > * {\n  flex: 1 1 50%;\n}\n\n.delete_button {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"check_and_notes_container": `Biobanks-module_check_and_notes_container_LK_1Z`,
	"biobank_button_container": `Biobanks-module_biobank_button_container_Y6X0a`,
	"delete_button": `Biobanks-module_delete_button_y8wYC`
};
export default ___CSS_LOADER_EXPORT___;
